var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"null_box"},[_c('img',{attrs:{"src":require("../img/null_pic.png"),"alt":""}}),_c('div',{staticClass:"null_box_text"},[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }